import { Injectable, isDevMode } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { getCurrentLanguageFromPath, getCurrentLanguagePath } from 'src/app/shared/utils';
import { ChangeLanguage } from '../actions/language.actions';

@Injectable()
export class LanguageEffects {
    changeLanguage$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ChangeLanguage),
                map(({ language }) => {
                    const currentLang = getCurrentLanguageFromPath();
                    const currentLangPath = getCurrentLanguagePath();
                    const currentPath = window.location.pathname;
                    const currentPathWithoutLang = currentPath.startsWith(currentLangPath)
                        ? currentPath.replace(new RegExp(`^${currentLangPath}`), '')
                        : currentPath;

                    if (!isDevMode() && (!currentLang || currentLang.countryCode !== language.countryCode)) {
                        location.href = '/' + language.countryCode + currentPathWithoutLang;
                    }
                })
            ),
        { dispatch: false }
    );

    constructor(private actions$: Actions) {}
}
